/**
 * ChatBotボタン
 */

import { useAppState } from 'hooks/useAppState';
import { useAtom } from 'jotai';
import { AcctState } from 'stores/atoms/acctState';

import type { JSX } from 'react';

type Props = {
  onOpen: () => void;
  title: string;
};

export default function WsModalChatbotButton({ onOpen, title }: Props): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useAtom(AcctState);
  const { getActivePlan } = useAppState();

  const activePlan = getActivePlan();
  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * AIテキスト生成数の上限に達しているかどうかを判定します。
   */
  const _isAiTextCountLimit = (): boolean => {
    return acctState.company.aiTextUsageCount >= (activePlan?.aiTextCountLimit ?? 0);
  };
  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      {!_isAiTextCountLimit() && (
        <div className="branq-fab" onClick={onOpen} style={{ userSelect: 'none' }}>
          <img src="/img/icon/question.svg" alt="AI" />
          <span>{title}</span>
        </div>
      )}
    </>
  );
}
